// extracted by mini-css-extract-plugin
export default {"card":"x3-z","carouselContainer":"y3-z","carouselContent":"z3-z"};